import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InterestRegisterEntryTypeConfig } from 'common/constants/assists-interest-register.constants';

@Component({
    selector: 'app-interest-register-entry-type-card',
    templateUrl: './entry-type-card.component.html',
    styleUrls: ['./entry-type-card.component.scss'],
})
export class InterestRegisterEntryTypeCardComponent {
    @Input({ required: true }) config!: InterestRegisterEntryTypeConfig;
    @Output() selected = new EventEmitter<InterestRegisterEntryTypeConfig>();

    select(): void {
        this.selected.emit(this.config);
    }
}
